import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";

import ShareToCard from "./ShareToCard";
import ButtonBlue from "../../components/Button/ButtonBlue";
import { hideShareto, emptyList } from "../../redux/actions/sharePost";
import { getChange } from "../../redux/actions/journal";
import Cancel from "../../common/images/cancel.png";
import ShareIcon from "@mui/icons-material/Share";
import "../../styles/shared.styles.scss";
import axios from "axios";
import { serverUrl } from "../../components/Helpers/Config";
import CachedIcon from "@mui/icons-material/Cached";
import Swal from "sweetalert2";
import { getCommunityFeed } from "../../redux/actions/userReflection";
import {
  BgPostButton,
  ButtonCommonTopGrey,
  ButtonCommonTopNew,
  Card,
  ModalInActive,
} from "../Theme";
import SearchBar from "../../components/Searchbar";
import { tokenAuthorize } from "../../components/Helpers/Common";
import NavTabs from "../../components/Navbar/NavTabs";

function ShareTo({ sharedComplete, journal }) {
  const dispatch = useDispatch();

  const showShareTo = useSelector((state) => state.showsharepost.show2);
  // const targetGroups = useSelector(state => state.reflections.groups)
  const selectedPosts = useSelector((state) => state.showsharepost.list);
  const userProfile = useSelector((state) => state.auth.user);

  const tabs = [
    { text: "Group", id: 1 },
    { text: "User", id: 2 },
  ];
  const profile = {
    name: userProfile ? userProfile.fullname : "",
    email: userProfile ? userProfile.email : "",
    programme: userProfile ? userProfile.programme : "",
    photo: userProfile ? userProfile.photo : "",
    cover: userProfile ? userProfile.cover : "",
  };

  const [currentPage, setCurrentPage] = useState(1);
  const [targetGroups, setTargetGroups] = useState([]);
  const [filteredGroups, setFilteredGroups] = useState([]);
  const [searchText, setSearchText] = useState("");
  const [targetUsers, setTargetUsers] = useState([]);
  const [filteredUsers, setFilteredUsers] = useState([]);
  const [userNotFound, setUserNotFound] = useState(false);

  const [selected, setSelected] = useState([]);
  const [selectedOld, setSelectedOld] = useState([]);
  const [selectedCompare, setSelectedCompare] = useState([]);
  const selectedGroupIds = selected.map((item) => item.id);
  const selectedUserIds = selected.map((item) => item.user_id);
  const isChange = useSelector((state) => state.journal.change);

  const [isStudent, setisStudent] = useState(false);
  const [isTutor, setisTutor] = useState(false);
  const [update, setUpdate] = useState(false);

  function dispatchCommunity() {
    axios
      .get(serverUrl.sharedPosts)
      .then((res) => {
        if (res.status === 200) {
        }
      })
      .catch((err) => {
        tokenAuthorize(err?.response?.status);
      });
  }

  useEffect(() => {
    if (userProfile.role === "MANAGER") {
      setisTutor(true);
      setisStudent(false);
    }
    if (userProfile.role === "MEMBER") {
      setisTutor(false);
      setisStudent(true);
    }
  }, [userProfile]);

  useEffect(() => {
    if (isTutor || isStudent) {
      axios
        .get(
          `${serverUrl.CommunityGroupsv3}?is_tutor=${isTutor}&is_student=${isStudent}`
        )
        .then((resp) => {
          if (resp.status === 200) {
            const groups = resp.data;
            setTargetGroups(groups);
          }
        });
    }
  }, [isTutor, isStudent]);

  useEffect(() => {
    let filteredItems = targetGroups?.filter(
      (group) => !selectedGroupIds.includes(group.id)
    );
    filteredItems = filteredItems.filter((group) =>
      group.name.toLowerCase().includes(searchText.toLowerCase())
    );
    setFilteredGroups(filteredItems);
  }, [searchText, targetGroups, selected]);

  useEffect(() => {
    if (selectedPosts.length === 1) {
      let reflection_id = selectedPosts[0].reflection_id;
      axios
        .get(serverUrl.sharedPost + `/${reflection_id}`)
        .then((res) => {
          if (res.status === 200) {
            if (currentPage === 1) {
              let groups = res.data.shared_group_id;
              let selectedGroup = targetGroups.filter((data) => {
                if (groups.includes(parseInt(data.id))) {
                  return data;
                }
              });
              setSelected(selectedGroup);
              if (selectedGroup?.length > 0) {
                setUpdate(true);
              } else {
                setUpdate(false);
              }
              setSelectedCompare(groups);
            }
            if (currentPage === 2) {
              let users = res.data.shared_user_id;
              let ids = users.map((data) => {
                return data.user_id;
              });
              setSelected(users);
              if (users?.length > 0) {
                setUpdate(true);
              } else {
                setUpdate(false);
              }
              setSelectedCompare(ids);
            }
          }
        })
        .catch((err) => {
          tokenAuthorize(err?.response?.status);
        });
    }
  }, [selectedPosts, targetGroups, currentPage]);

  useEffect(() => {
    let filteredItems = targetUsers.filter(
      (user) => !selectedUserIds.includes(user.user_id)
    );
    setFilteredUsers(filteredItems);
  }, [selected, targetUsers]);

  useEffect(() => {
    setUserNotFound(false);
    setFilteredUsers([]);
  }, [searchText]);

  const switchTab = (id) => {
    setCurrentPage(id);
    setSelected([]);
    setSearchText("");
    setSelectedOld([]);
    setSelectedCompare([]);
  };

  const handleSearchUser = () => {
    axios
      .post(serverUrl.User2 + `/search/${searchText}`)
      .then((resp) => {
        if (resp.status === 200) {
          const users = resp.data.users_list;
          if (users.length === 0) {
            setUserNotFound(true);
          } else {
            setUserNotFound(false);
          }
          setTargetUsers(users);
        }
      })
      .catch((err) => {
        tokenAuthorize(err?.response?.status);
        Swal.fire({
          title: "Info",
          text: "Search word should be minimum 3 character",
          icon: "info",
        });
        setTargetUsers([]);
      });
  };

  function Share() {
    if (currentPage === 1) {
      //share to group
      // single post sharing process for group
      if (selectedPosts.length === 1) {
        let oldIds = selectedOld.map((data) => {
          return data.id;
        });
        let data = oldIds.filter((data) => {
          if (selectedCompare.includes(parseInt(data))) {
            return data;
          }
        });
        axios
          .post(serverUrl.CommunitySharePost, {
            group_id: selected.map((group) => group.id),
            reflection_id: selectedPosts[0].reflection_id,
            unshared_group_id: data,
          })
          .then((resp) => {
            if (resp.status === 200) {
              // dispatchCommunity();
              dispatch(getChange(!isChange));
              dispatch(getCommunityFeed(0, isTutor, isStudent));
              Swal.fire({ title: "Success", icon: "success" });
              close();
              close();
            } else if (resp.status === 204) {
              Swal.fire(
                "Duplicate post",
                "You have shared the content to the group" +
                  (selected.length > 1 ? "s" : ""),
                "error"
              );
            }
          })
          .catch((err) => {
            tokenAuthorize(err?.response?.status);
            console.log(err);
          });
      }
      // multiple post sharing process for group
      else {
        axios
          .post(serverUrl.Community, {
            groups: selected.map((group) => group.id),
            posts: selectedPosts.map((post) => post.reflection_id),
          })
          .then((resp) => {
            if (resp.status === 200) {
              // dispatchCommunity();
              dispatch(getChange(!isChange));
              dispatch(getCommunityFeed(0, isTutor, isStudent));
              Swal.fire({ title: "Success", icon: "success" });
              close();
            } else if (resp.status === 204) {
              Swal.fire(
                "Duplicate post",
                "You have shared the content to the group" +
                  (selected.length > 1 ? "s" : ""),
                "error"
              );
            }
          })
          .catch((err) => {
            tokenAuthorize(err?.response?.status);
            console.log(err);
          });
      }
    } else if (currentPage === 2) {
      // share to user
      // single post sharing process for user
      if (selectedPosts.length === 1) {
        let oldIds = selectedOld.map((data) => {
          return data.user_id;
        });
        let data = oldIds.filter((data) => {
          if (selectedCompare.includes(parseInt(data))) {
            return data;
          }
        });
        axios
          .post(serverUrl.UserSharePost, {
            share_to: selected
              .map((user) => user.user_id)
              .filter((data) => {
                if (!selectedCompare.includes(parseInt(data))) {
                  return data;
                }
              }),
            reflection_id: selectedPosts[0].reflection_id,
            unshared_user_id: data,
          })
          .then((resp) => {
            if (resp.status === 200) {
              // dispatchCommunity();
              dispatch(getChange(!isChange));
              dispatch(getCommunityFeed(0, isTutor, isStudent));
              Swal.fire({ title: "Success", icon: "success" });
              close();
            } else if (resp.status === 204) {
              Swal.fire(
                "Duplicate post",
                "You have shared the content to the group" +
                  (selected.length > 1 ? "s" : ""),
                "error"
              );
            }
          })
          .catch((err) => {
            tokenAuthorize(err?.response?.status);
            console.log(err);
          });
      }
      //multiple post sharing process for user
      else {
        axios
          .post(serverUrl.ReflectionGroups + "/share", {
            user_id: selected.map((user) => user.user_id),
            reflection_id: selectedPosts.map((post) => post.reflection_id),
          })
          .then((resp) => {
            if (resp.status === 200) {
              dispatch(getChange(!isChange));
              dispatch(getCommunityFeed(0, isTutor, isStudent));
              Swal.fire({ title: "Success", icon: "success" });
              close();
            }
          })
          .catch((err) => {
            tokenAuthorize(err?.response?.status);
            console.log(err);
            Swal.fire(
              "Duplicate post",
              "You have shared the content to the user" +
                (selected.length > 1 ? "s" : ""),
              "error"
            );
          });
      }
    }
    if (journal == true) {
      sharedComplete([]);
    }
  }

  const addGroup = (id) => {
    const newList = [
      ...selected,
      ...targetGroups.filter((item) => item.id === id),
    ];

    setSelected(newList);
  };

  const addUser = (id) => {
    const newList = [
      ...selected,
      ...targetUsers.filter((item) => item.user_id === id),
    ];
    setSelected(newList);
  };

  const removeGroup = (id) => {
    const newList = [...selected.filter((item) => item.id !== id)];
    const oldList = [...selected.filter((item) => item.id === id)];
    setSelected(newList);
    setSelectedOld(oldList);
  };

  const removeUser = (id) => {
    const newList = [...selected.filter((item) => item.user_id !== id)];
    const oldList = [...selected.filter((item) => item.user_id === id)];
    setSelected(newList);
    setSelectedOld(oldList);
  };

  function close() {
    dispatch(emptyList());
    dispatch(hideShareto());
    setSelected([]);
    setSelectedOld([]);
    setSelectedCompare([]);
    setSearchText("");
    setTargetUsers([]);
  }

  return showShareTo ? (
    <div className="flex justify-center  items-center fixed top-0 left-0 modelIndex w-full h-full bg-black bg-opacity-30">
      <Card className="w-3/4 lg:w-1/2 p-5 pb-2  rounded-lg overflow-hidden border20px popUpWidth">
        <div className=" flex items-center justify-between">
          <div className="w-full font-semibold blackColor flex items-center">
            Share Post
          </div>
          <button
            onClick={close}
            class="text-gray-600 hover:text-black text-xl font-bold"
          >
            ×
          </button>
          {/* <div className='' onClick={close} >
                        <img src={Cancel} className='w-5 h-5 opacity-30 cursor-pointer' />
                    </div> */}
        </div>
        {/* <hr className=''/> */}

        <div className=" flex flex-row items-center mt-2 justify-between">
          <NavTabs
            menuLinks={[
              {
                title: "Group",
                index: 1,
                onChange: (e) => {
                  switchTab(1);
                },
              },
              {
                title: "User",
                index: 2,
                onChange: (e) => {
                  switchTab(2);
                },
              },
            ]}
            value={currentPage}
            padding={false}
            isDot={false}
          />
          {update == true ? (
            <>
              <ButtonCommonTopNew
                onClick={Share}
                className="px-4 py-2 rounded-lg text-sm cursor-pointer flex items-center gap-1"
              >
                <CachedIcon
                  style={{ fontSize: "20px" }}
                  className="blueColor"
                />
                Update
              </ButtonCommonTopNew>
            </>
          ) : (
            <ButtonCommonTopNew
              onClick={selected.length == 0 ? null : Share}
              className={`px-4 py-2 rounded-lg text-sm  flex items-center gap-1 ${
                selected.length == 0 ? "opacity-40 pointer-events-none cursor-default" : "cursor-pointer"
              } `}
            >
              <ShareIcon style={{ fontSize: "15px" }} className="blueColor" />
              Share
            </ButtonCommonTopNew>
          )}
        </div>

        <div className=" pt-4 flex flex-col gap-6">
          {currentPage === 1 && (
            <div className="flex flex-col">
              <div className="flex flex-col md:flex-row mb-2 md:items-center ">
                <label className="text-sm mr-5 mb-2 md:mb-0 whitespace-nowrap font-semibold">
                  Share to Group
                </label>
                <SearchBar setSearchField={setSearchText} onClick={() => {}} />
              </div>
              <div className="flex flex-col h-72 overflow-y-auto space-y-3 mt-5">
                {selected.length !== 0 && (
                  <>
                    <div className="flex flex-row items-center">
                      <p className="text-sm mr-2 mb-2 md:mb-0 whitespace-nowrap font-semibold">
                        Selected
                      </p>
                      <hr />
                    </div>
                    {selected.map((group, index) => (
                      <ShareToCard
                        item={group}
                        idx={index}
                        add={addGroup}
                        remove={removeGroup}
                        key={index}
                        isSelected={selected.some((el) => el.id === group.id)}
                      />
                    ))}
                  </>
                )}

                <div className="flex flex-row items-center">
                  <p className="text-sm mr-2 mb-2 md:mb-0 whitespace-nowrap font-semibold">
                    Groups
                  </p>
                  <hr />
                </div>
                {filteredGroups.map(
                  (group, index) =>
                    group.is_parent == false &&
                    group.user_can_post == true && (
                      <ShareToCard
                        item={group}
                        idx={index}
                        add={addGroup}
                        remove={removeGroup}
                        key={index}
                        isSelected={selected.some((el) => el.id === group.id)}
                      />
                    )
                )}
              </div>
            </div>
          )}
          {currentPage === 2 && (
            <>
              <div className="flex flex-col">
                {/* <div className="grid md:grid-cols-3 mb-2 md:items-center ">
                  <label className="col-span-1 text-sm mr-5 mb-2 md:mb-0 whitespace-nowrap font-bold">
                    Share to Friends
                  </label>
                  <div className="col-span-2">
                    <SearchBar
                      setSearchField={setSearchText}
                      onClick={handleSearchUser}
                    />
                  </div>
                </div> */}
                <div className="flex flex-col md:flex-row mb-2 md:items-center ">
                  <label className="text-sm mr-5 mb-2 md:mb-0 whitespace-nowrap font-semibold">
                    Share to Friends
                  </label>
                  <SearchBar
                    setSearchField={setSearchText}
                    onClick={handleSearchUser}
                  />
                </div>
                <div className="grid md:grid-cols-3">
                  <div className="col-span-1" />
                  {searchText.length < 3 && (
                    <span className="col-span-2 cover-file-show-error mt-1"></span>
                  )}
                </div>

                <div className="flex flex-col h-72 overflow-y-auto space-y-3 mb-5">
                  {selected.length !== 0 && (
                    <>
                      <div className="flex flex-row items-center">
                        <p className="text-sm mr-2 mb-2 md:mb-0 whitespace-nowrap font-bold">
                          Selected
                        </p>
                        <hr />
                      </div>
                      {selected.map((user, index) => (
                        <ShareToCard
                          item={user}
                          idx={index}
                          add={() => addUser(user.user_id)}
                          remove={() => removeUser(user.user_id)}
                          key={index}
                          isSelected={selected.some(
                            (el) => el.user_id === user.user_id
                          )}
                          isUser={true}
                        />
                      ))}
                    </>
                  )}

                  <div className="flex flex-row items-center">
                    <p className="text-sm mr-2 mb-2 md:mb-0 whitespace-nowrap font-bold">
                      Users
                    </p>
                    <hr />
                  </div>

                  {searchText.length !== 0 ? (
                    <>
                      {userNotFound === false ? (
                        filteredUsers.map((user, index) => (
                          <ShareToCard
                            item={user}
                            idx={index}
                            add={() => addUser(user.user_id)}
                            remove={() => removeUser(user.user_id)}
                            key={index}
                            isSelected={selected.some(
                              (el) => el.user_id === user.user_id
                            )}
                            isUser={true}
                          />
                        ))
                      ) : (
                        <p className="mr-2 mb-2 md:mb-0">User not found</p>
                      )}
                    </>
                  ) : (
                    <p className="mr-2 mb-2 md:mb-0">
                      Search user to share post
                    </p>
                  )}
                </div>
              </div>
            </>
          )}
        </div>
        <div className="w-full flex justify-center mb-5">
          {/* <ButtonBlue
            title={update === true ? "UPDATE" : "SHARE"}
            onClick={Share}
          /> */}
          {/* {update == true ? (
            <>
              <ButtonCommonTopNew
                onClick={Share}
                className="px-4 py-2 rounded-lg text-sm cursor-pointer flex items-center gap-1"
              >
                <CachedIcon style={{ fontSize: "20px" }} className="blueColor" />
                Update
              </ButtonCommonTopNew>
            </>
          ) : (
            <ButtonCommonTopNew
              onClick={Share}
              className="px-4 py-2 rounded-lg text-sm cursor-pointer flex items-center gap-1"
            >
              <ShareIcon style={{ fontSize: "15px" }} className="blueColor" />
              Share
            </ButtonCommonTopNew>
          )} */}
        </div>
      </Card>
    </div>
  ) : null;
}

export default ShareTo;
